import * as React from 'react';
import { connect } from 'react-redux';
import { editUsuario, fetchUsuarios } from '../../actions/usuariosActions';

class Contraseña extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            idSeller: this.props.seller.codigo,
            passwordActual: ""
        }
    };

    componentDidMount() {
        this.props.fetchUsuarios(this.state)
    }

    changePassword = (e) => {
        let usuario = {
            ...this.props.usuario,
            nuevoPassword: e.target.value,
            idSeller: this.props.seller.codigo,
            idUsuario: this.props.idUsuario[0].idUsuario
        }
        this.props.editUsuario({ 
            ...usuario, 
            nuevoPassword: e.target.value, 
            idSeller: this.props.seller.codigo, 
            passwordActual: this.state.passwordActual 
        });
    }

    confirmarPassword = (e) => {
        let usuario = this.props.usuario;
        this.props.editUsuario({ ...usuario, confirmarPassword: e.target.value });
    }

    passwordActual = (e) => {
        this.setState({ passwordActual: e.target.value });
    }


    render() {
        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">

                        <div className="form-group">
                            <label>Contraseña actual</label>
                            <input
                                type="password"
                                className="form-control"
                                value={this.state.passwordActual}
                                onChange={this.passwordActual}
                                placeholder=""
                                name="passwordActual" 
                            />
                        </div>

                        <div className="form-group">
                            <label>Nueva contraseña</label>
                            <input
                                type="password"
                                className="form-control"
                                value={this.props.usuario.nuevoPassword}
                                onChange={this.changePassword}
                                placeholder=""
                                name="nuevoPassword" 
                            />
                        </div>

                        <div className="form-group">
                            <label>Confirmar contraseña</label>
                            <input
                                type="password"
                                className={this.props.usuarioError ? "warning-input form-control" : "form-control"}
                                value={this.props.usuario.confirmarPassword}
                                onChange={this.confirmarPassword}
                                placeholder=""
                                name="confirmarPassword" 
                            />
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    usuario: state.usuarios.usuario,
    usuarioError: state.usuarios.error,
    idUsuario: state.usuarios.usuarios,
    seller:
        JSON.stringify(state.general.generalObject) != "{}"
        ? state.general.generalObject
        : state.sellers.seller
    ,
});

export default connect(mapStateToProps, { editUsuario, fetchUsuarios })(Contraseña); 